import { JSX } from 'react';
import { Box, Typography } from '@mui/material';
import { EmailFinder } from '../../../../../../types/entities';
import { formatDuration, formatTime } from '../email-finder-format';

/**
 * The four numbers that describe a run. They were four coloured labels crammed
 * into a 2x2 grid in the corner, read left to right as Start, Total New, End,
 * Total Found, which is not an order anything is in. Counts first, then the
 * clock, and only the counts carry a colour.
 */
const Tile: (props: { label: string, value: string, accent?: string }) => JSX.Element =
    (props: { label: string, value: string, accent?: string }): JSX.Element => (
        <Box sx={ {
            flex: '1 1 110px',
            minWidth: '104px',
            padding: '9px 12px',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            background: 'var(--wf-surface-2)',
        } }>
            <Typography sx={ {
                fontSize: 'var(--wf-eyebrow)',
                letterSpacing: 'var(--wf-track)',
                textTransform: 'uppercase',
                color: 'text.secondary',
                fontWeight: 700,
            } }>
                { props.label }
            </Typography>
            <Typography sx={ {
                fontSize: '17px',
                fontWeight: 600,
                lineHeight: 1.35,
                fontFamily: 'var(--wf-font-mono)',
                color: props.accent ?? 'text.primary',
            } }>
                { props.value }
            </Typography>
        </Box>
    );

export const ScanSummary: (props: { finder: EmailFinder }) => JSX.Element =
    (props: { finder: EmailFinder }): JSX.Element => {
        const finder: EmailFinder = props.finder;

        return (
            <Box sx={ { display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '14px' } }>
                <Tile label="Emails found" value={ String(finder?.totalFound ?? 0) } />
                <Tile label="New"
                      value={ String(finder?.totalNew ?? 0) }
                      accent={ (finder?.totalNew ?? 0) > 0 ? 'var(--wf-ok)' : undefined } />
                <Tile label="Started" value={ formatTime(finder?.startTime) } />
                <Tile label="Finished" value={ formatTime(finder?.endTime) } />
                <Tile label="Duration" value={ formatDuration(finder?.startTime, finder?.endTime) } />
            </Box>
        );
    }
